import { useState } from 'react'
import { TraderAcceptedWithdrawModel } from '../model'

export const useWithdrawsModal = () => {
  const [modalEditPayoutVisible, setModalEditPayoutVisible] = useState(false)
  const [modalActiveWithdrawVisible, setModalActiveWithdrawVisible] = useState(false)
  const [modalCancelLeadVisible, setModalCancelLeadVisible] = useState(false)
  const [modalConfirmationCancel, setModalConfirmationCancel] = useState(false)
  const [modalAppeals, setModalAppeals] = useState(false)
  const [modalCreateVisible, setModalCreateVisible] = useState(false)

  const [activeWithdraw, setActiveWithdraw] = useState<TraderAcceptedWithdrawModel | null>(null)

  const openCreateModal = () => setModalCreateVisible(true)
  const closeCreateModal = () => setModalCreateVisible(false)

  const openEditModal = () => setModalEditPayoutVisible(true)
  const closeEditModal = () => setModalEditPayoutVisible(false)

  const openActiveModal = () => setModalActiveWithdrawVisible(true)
  const closeActiveModal = () => setModalActiveWithdrawVisible(false)

  const openCancelModal = () => setModalCancelLeadVisible(true)
  const closeCancelModal = () => setModalCancelLeadVisible(false)

  const openConfirmationCancelModal = () => setModalConfirmationCancel(true)
  const closeConfirmationCancelModal = () => setModalConfirmationCancel(false)

  const openAppealsModal = () => setModalAppeals(true)
  const closeAppealsModal = () => setModalAppeals(false)

  const closeAllModals = () => {
    setModalEditPayoutVisible(false)
    setModalActiveWithdrawVisible(false)
    setModalCancelLeadVisible(false)
    setModalConfirmationCancel(false)
    setModalAppeals(false)
    setModalCreateVisible(false)
  }

  return {
    // State
    modals: {
      modalEditPayoutVisible,
      modalActiveWithdrawVisible,
      modalCancelLeadVisible,
      modalConfirmationCancel,
      modalAppeals,
      modalCreateVisible,
      activeWithdraw,
    },

    // Setters (для совместимости с существующими компонентами)
    setters: {
      setModalEditPayoutVisible,
      setModalActiveWithdrawVisible,
      setModalCancelLeadVisible,
      setModalConfirmationCancel,
      setModalAppeals,
      setModalCreateVisible,
      setActiveWithdraw,
    },

    // Actions
    actions: {
      openCreateModal,
      closeCreateModal,
      openEditModal,
      closeEditModal,
      openActiveModal,
      closeActiveModal,
      openCancelModal,
      closeCancelModal,
      openConfirmationCancelModal,
      closeConfirmationCancelModal,
      openAppealsModal,
      closeAppealsModal,
      closeAllModals,
    },
  }
}
